(() => {
  function priceIncGst(exGstPrice) {
    const price = Number(exGstPrice) || 0;
    return price * 1.10;
  }

  function formatDisplayPrice(value) {
    const amount = Number(value) || 0;
    return `$${Math.round(amount)}`;
  }

  function normaliseValue(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replaceAll('_', '-')
      .replace(/\s+/g, '-');
  }

  function resetSelect(select, placeholder) {
    if (!select) {
      return;
    }

    select.innerHTML = '';

    const option = document.createElement('option');

    option.value = '';
    option.textContent = placeholder;

    select.appendChild(option);
  }

  function appendOption(select, item) {
    if (!select || !item) {
      return;
    }

    const option = document.createElement('option');

    option.value = item.handle;
    option.textContent = item.name || item.handle;
    option.dataset.code = item.code || '';

    select.appendChild(option);
  }

  function uniqueByHandle(items) {
    const map = new Map();

    items.forEach((item) => {
      if (item?.handle && !map.has(item.handle)) {
        map.set(item.handle, item);
      }
    });

    return [...map.values()];
  }

  function isRollerBlindModel(model) {
    const productTypes = Array.isArray(model.productTypes)
      ? model.productTypes
      : [];

    if (!productTypes.length) {
      return false;
    }

    return productTypes.some((productType) => {
      const value = normaliseValue(productType);

      return (
        value === 'roller-blind' ||
        value.includes('roller-blind')
      );
    });
  }

  function initialiseMotorModule(root) {
    if (
      !root ||
      root.dataset.smartQuoteMotorsReady === 'true'
    ) {
      return;
    }

    const sectionId = root.dataset.sectionId;

    const dataElement = document.getElementById(
      `SmartQuoteData-${sectionId}`
    );

    if (!dataElement) {
      console.warn(
        `Motor data could not start because Smart Quote data was not found for section ${sectionId}.`
      );

      return;
    }

    let motorData = {
  brands: [],
  powerTypes: [],
  models: [],
  remotes: [],
  chargers: [],
  selectionRules: []
};

    try {
      const parsedData = JSON.parse(dataElement.textContent);
      const parsedMotors = parsedData.motors || {};

      motorData = {
        brands: Array.isArray(parsedMotors.brands)
          ? parsedMotors.brands
          : [],

        powerTypes: Array.isArray(parsedMotors.powerTypes)
          ? parsedMotors.powerTypes
          : [],

        models: Array.isArray(parsedMotors.models)
          ? parsedMotors.models
          : [],

        remotes: Array.isArray(parsedMotors.remotes)
          ? parsedMotors.remotes
          : [],

        chargers: Array.isArray(parsedMotors.chargers)
          ? parsedMotors.chargers
          : [],
          selectionRules: Array.isArray(
    parsedData.motorSelectionRules
  )
    ? parsedData.motorSelectionRules
    : []
      };
    } catch (error) {
      console.error(
        'Motor data could not be read.',
        error
      );

      return;
    }

    const form = root.querySelector(
      '[data-smart-quote-form]'
    );

    if (!form) {
      return;
    }
    const productType = root.dataset.productType || '';
    const widthField = form.elements.width;
const dropField = form.elements.drop;

function getMotorWidthEligibility() {
  const width = Number(widthField?.value);

  if (!Number.isFinite(width) || width <= 0) {
    return {
      motorisedAllowed: false,
      batteryAllowed: false,
      wiredAllowed: false
    };
  }

  if (width < 550) {
    return {
      motorisedAllowed: false,
      batteryAllowed: false,
      wiredAllowed: false
    };
  }

  if (width < 670) {
    return {
      motorisedAllowed: true,
      batteryAllowed: true,
      wiredAllowed: false
    };
  }

  return {
    motorisedAllowed: true,
    batteryAllowed: true,
    wiredAllowed: true
  };
}

function getSelectedBlindType() {
  return form.querySelector(
    'input[name="blind_type"]:checked'
  )?.value || '';
}

function getRequiredTorque() {
  const width = widthField?.value;
  const drop = dropField?.value;
  const blindType = getSelectedBlindType();

  const area = calculateArea(width, drop);

  if (!area || !blindType) {
    return null;
  }

  const matchingRule = findMotorSelectionRule({
   productType,
    blindType,
    area,
    rules: motorData.selectionRules
  });

  if (!matchingRule) {
    return null;
  }

  return {
    area,
    torque: Number(matchingRule.requiredTorque),
    rule: matchingRule
  };
}

    const motorBrandSelect = form.elements.motor_brand;
    const powerTypeSelect = form.elements.power_type;
    const remoteSelect = form.elements.remote;
    const chargerSelect = form.elements.charger;
    const motorModelField = form.elements.motor_model;
    const motorBrandCards = root.querySelector(
  '[data-motor-brand-cards]'
);
const powerTypeCards = root.querySelector(
  '[data-power-type-cards]'
);

const remoteCards = root.querySelector(
  '[data-remote-cards]'
);
const chargerCards = root.querySelector(
  '[data-charger-cards]'
);
const selectedMotorCard = root.querySelector(
  '[data-selected-motor-card]'
);

const requiredTorqueField = form.elements.required_torque;
const calculatedAreaField = form.elements.calculated_area;
    if (remoteSelect) {
  remoteSelect.required = false;
}

if (chargerSelect) {
  chargerSelect.required = false;
}

    const chargerField = root.querySelector(
      '[data-charger-field]'
    );

    if (
      !motorBrandSelect ||
      !powerTypeSelect ||
      !remoteSelect
    ) {
      console.warn(
        'Motor dropdowns could not be found.'
      );

      return;
    }

    root.dataset.smartQuoteMotorsReady = 'true';

    function getRollerBlindModels() {
      const rollerModels =
        motorData.models.filter(isRollerBlindModel);

      /*
       * Temporary fallback:
       * If Product Types have not yet been entered on every model,
       * do not leave the wizard empty.
       */
      return rollerModels.length
        ? rollerModels
        : motorData.models;
    }

     
function getTorqueCompatibleModels() {
  const torqueResult = getRequiredTorque();

  if (!torqueResult) {
    return [];
  }

  return getRollerBlindModels().filter((model) => {
    const modelTorque = Number(
      model.torque ?? model.ratedTorque
    );

    return modelTorque === Number(
      torqueResult.torque
    );
  });
}
function findAutomaticMotorModel() {
  const torqueResult = getRequiredTorque();
  const brandHandle = motorBrandSelect?.value || '';
  const powerTypeHandle = powerTypeSelect?.value || '';

  if (
    !torqueResult ||
    !brandHandle ||
    !powerTypeHandle
  ) {
    return null;
  }

  return motorData.models.find((model) => {
    const modelTorque = Number(
      model.torque ?? model.ratedTorque
    );

    const brandMatches =
      normaliseValue(model.motorBrand) ===
      normaliseValue(brandHandle);

    const powerTypeMatches =
      normaliseValue(model.powerType) ===
      normaliseValue(powerTypeHandle);

    const productTypes = Array.isArray(model.productTypes)
      ? model.productTypes
      : [];

    const productTypeMatches =
      productTypes.some((type) => {
        const modelProductType =
          normaliseValue(type);

        const selectedProductType =
          normaliseValue(productType);

        return (
          modelProductType === selectedProductType ||
          modelProductType.includes(selectedProductType) ||
          selectedProductType.includes(modelProductType)
        );
      });

    return (
      brandMatches &&
      powerTypeMatches &&
      productTypeMatches &&
      modelTorque === Number(torqueResult.torque)
    );
  }) || null;
}
function updateAutomaticMotorModel() {
  if (motorModelField) {
    motorModelField.value = '';
  }

  if (requiredTorqueField) {
    requiredTorqueField.value = '';
  }

  if (calculatedAreaField) {
    calculatedAreaField.value = '';
  }

  const torqueResult = getRequiredTorque();
  const brandHandle = motorBrandSelect?.value || '';
  const powerTypeHandle = powerTypeSelect?.value || '';

  if (!torqueResult) {
    return null;
  }

  if (requiredTorqueField) {
    requiredTorqueField.value = String(
      torqueResult.torque
    );
  }

  if (calculatedAreaField) {
    calculatedAreaField.value =
      torqueResult.area.toFixed(2);
  }

  if (!brandHandle || !powerTypeHandle) {
    return null;
  }

  const matchingMotor = findAutomaticMotorModel();

 if (!matchingMotor) {
  return null;
}

    if (motorModelField) {
    motorModelField.value =
      matchingMotor.name ||
      matchingMotor.handle ||
      '';
  }
 if (selectedMotorCard) {
  selectedMotorCard.innerHTML = '';
  selectedMotorCard.hidden = true;
} 

  return matchingMotor;
}

    function populateMotorBrands() {
      resetSelect(
        motorBrandSelect,
        'Select a brand'
      );

      resetSelect(
        powerTypeSelect,
        'Select a power type'
      );

      resetSelect(
  remoteSelect,
  'Select a remote'
);

      if (chargerSelect) {
        resetSelect(
  chargerSelect,
  'Select a charger'
);
      }

      const availableBrandHandles = new Set(
  getTorqueCompatibleModels()
    .map((model) => model.motorBrand)
    .filter(Boolean)
);

      const availableBrands =
        motorData.brands.filter((brand) => {
          return availableBrandHandles.has(
            brand.handle
          );
        });

        if (motorBrandCards) {
  motorBrandCards.innerHTML = '';

  availableBrands.forEach((brand) => {
    const card = document.createElement('button');

    card.type = 'button';
    card.className =
      'smart-quote__option-card smart-quote__visual-card';

    card.dataset.motorBrandHandle = brand.handle;

    if (brand.image) {
      const imageWrap = document.createElement('div');
      imageWrap.className =
        'smart-quote__visual-card-media';

      const image = document.createElement('img');
      image.src = brand.image;
      image.alt = brand.name || brand.handle;
      image.loading = 'lazy';
      image.className =
        'smart-quote__visual-card-image';

      imageWrap.appendChild(image);
      card.appendChild(imageWrap);
    }

    const content = document.createElement('span');
    content.className =
      'smart-quote__visual-card-content';

    const title = document.createElement('strong');
    title.className =
      'smart-quote__visual-card-title';

    title.textContent =
      brand.name || brand.handle;

    content.appendChild(title);
    card.appendChild(content);

    card.addEventListener('click', () => {
      motorBrandSelect.value = brand.handle;

      motorBrandCards
        .querySelectorAll('.smart-quote__visual-card')
        .forEach((item) => {
          item.classList.remove('is-selected');
        });

      card.classList.add('is-selected');

      motorBrandSelect.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    });

    motorBrandCards.appendChild(card);
  });
}

      availableBrands.forEach((brand) => {
        appendOption(motorBrandSelect, brand);
      });
    }

    function populatePowerTypes(brandHandle) {
      resetSelect(
        powerTypeSelect,
        'Select a power type'
      );

      resetSelect(
        remoteSelect,
        'No Remote'
      );

      if (chargerSelect) {
        resetSelect(
          chargerSelect,
          'No Charger'
        );
      }

      if (!brandHandle) {
        return;
      }

     const availablePowerTypeHandles = new Set(
  getTorqueCompatibleModels()
    .filter((model) => {
      return model.motorBrand === brandHandle;
    })
    .map((model) => model.powerType)
    .filter(Boolean)
);

      const widthEligibility =
  getMotorWidthEligibility();

const availablePowerTypes =
  motorData.powerTypes.filter((powerType) => {
    if (
      !availablePowerTypeHandles.has(
        powerType.handle
      )
    ) {
      return false;
    }

    const normalisedPowerType =
      normaliseValue(powerType.handle);

    if (
      normalisedPowerType.includes('battery')
    ) {
      return widthEligibility.batteryAllowed;
    }

    if (
      normalisedPowerType.includes('wired') ||
      normalisedPowerType.includes('hardwired')
    ) {
      return widthEligibility.wiredAllowed;
    }

    return true;
  });

        if (powerTypeCards) {
  powerTypeCards.innerHTML = '';

  availablePowerTypes.forEach((powerType) => {
    const card = document.createElement('button');

    card.type = 'button';
    card.className =
      'smart-quote__option-card smart-quote__visual-card';

    card.dataset.powerTypeHandle = powerType.handle;

    if (powerType.image) {
      const imageWrap = document.createElement('div');
      imageWrap.className =
        'smart-quote__visual-card-media';

      const image = document.createElement('img');
      image.src = powerType.image;
      image.alt = powerType.name || powerType.handle;
      image.loading = 'lazy';
      image.className =
        'smart-quote__visual-card-image';

      imageWrap.appendChild(image);
      card.appendChild(imageWrap);
    }

    const content = document.createElement('span');
    content.className =
      'smart-quote__visual-card-content';

    const title = document.createElement('strong');
    title.className =
      'smart-quote__visual-card-title';

    title.textContent =
      powerType.name || powerType.handle;

    content.appendChild(title);
    card.appendChild(content);

    card.addEventListener('click', () => {
      powerTypeSelect.value = powerType.handle;

      powerTypeCards
        .querySelectorAll('.smart-quote__visual-card')
        .forEach((item) => {
          item.classList.remove('is-selected');
        });

      card.classList.add('is-selected');

      powerTypeSelect.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    });

    powerTypeCards.appendChild(card);
  });
}

      availablePowerTypes.forEach((powerType) => {
        appendOption(powerTypeSelect, powerType);
      });
    }

    function populateCompatibleAccessories(
      brandHandle,
      powerTypeHandle
    ) {
      resetSelect(
        remoteSelect,
        'Select a remote'
      );

      if (chargerSelect) {
        resetSelect(
          chargerSelect,
          'No Charger'
        );
      }

      if (!brandHandle || !powerTypeHandle) {
        return;
      }

      const matchingMotor = findAutomaticMotorModel();

const matchingModels = matchingMotor
  ? [matchingMotor]
  : [];

const remoteHandles = new Set();

if (matchingMotor) {
  const compatibleRemotes = Array.isArray(
    matchingMotor.compatibleRemotes
  )
    ? matchingMotor.compatibleRemotes
    : [];

  compatibleRemotes.forEach((handle) => {
    remoteHandles.add(handle);
  });
}

      let compatibleRemotes =
        motorData.remotes.filter((remote) => {
          return remoteHandles.has(remote.handle);
        });

      /*
       * Fallback:
       * If Compatible Remotes have not been linked to a model,
       * use Remote Brand + Power Type.
       */
      if (!compatibleRemotes.length) {
      compatibleRemotes =
      motorData.remotes.filter((remote) => {
      return remote.motorBrand === brandHandle;
     });
}
appendOption(remoteSelect, {
  handle: 'no-remote',
  name: 'No Remote'
});
      uniqueByHandle(compatibleRemotes).forEach(
        (remote) => {
          appendOption(remoteSelect, remote);
        }
      );
      if (remoteCards) {
  remoteCards.innerHTML = '';

  // No Remote card
  const noRemoteCard = document.createElement('button');
  noRemoteCard.type = 'button';
  noRemoteCard.className =
    'smart-quote__option-card smart-quote__visual-card';
  noRemoteCard.dataset.remoteHandle = 'no-remote';

  const noRemoteContent = document.createElement('span');
  noRemoteContent.className =
    'smart-quote__visual-card-content';

  const noRemoteTitle = document.createElement('strong');
  noRemoteTitle.className =
    'smart-quote__visual-card-title';
  noRemoteTitle.textContent = 'No Remote';

  noRemoteContent.appendChild(noRemoteTitle);
  noRemoteCard.appendChild(noRemoteContent);

  noRemoteCard.addEventListener('click', () => {
    remoteSelect.value = 'no-remote';

    remoteCards
      .querySelectorAll('.smart-quote__visual-card')
      .forEach((item) => {
        item.classList.remove('is-selected');
      });

    noRemoteCard.classList.add('is-selected');

    remoteSelect.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  });

  remoteCards.appendChild(noRemoteCard);

  // Compatible Remote cards
  uniqueByHandle(compatibleRemotes).forEach((remote) => {
    const card = document.createElement('button');

    card.type = 'button';
    card.className =
      'smart-quote__option-card smart-quote__visual-card';

    card.dataset.remoteHandle = remote.handle;

    if (remote.image) {
      const imageWrap = document.createElement('div');
      imageWrap.className =
        'smart-quote__visual-card-media';

      const image = document.createElement('img');
      image.src = remote.image;
      image.alt = remote.name || remote.handle;
      image.loading = 'lazy';
      image.className =
        'smart-quote__visual-card-image';

      imageWrap.appendChild(image);
      card.appendChild(imageWrap);
    }

    const content = document.createElement('span');
    content.className =
      'smart-quote__visual-card-content';

    const title = document.createElement('strong');
    title.className =
      'smart-quote__visual-card-title';
    title.textContent =
      remote.name || remote.handle;

    content.appendChild(title);

    const price = Number(remote.sellingPrice || 0);

    if (price > 0) {
      const priceText = document.createElement('small');
   priceText.textContent =
  `+${formatDisplayPrice(
    priceIncGst(price)
  )}`;
      content.appendChild(priceText);
    }

    card.appendChild(content);

    card.addEventListener('click', () => {
      remoteSelect.value = remote.handle;

      remoteCards
        .querySelectorAll('.smart-quote__visual-card')
        .forEach((item) => {
          item.classList.remove('is-selected');
        });

      card.classList.add('is-selected');

      remoteSelect.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    });

    remoteCards.appendChild(card);
  });
}

      const isBattery =
        normaliseValue(powerTypeHandle).includes(
          'battery'
        );

      if (!chargerField || !chargerSelect) {
        return;
      }

      chargerField.hidden = !isBattery;
chargerSelect.disabled = !isBattery;
chargerSelect.required = false;

      if (!isBattery) {
        return;
      }

      const chargerHandles = new Set();

      matchingModels.forEach((model) => {
        const compatibleChargers = Array.isArray(
          model.compatibleChargers
        )
          ? model.compatibleChargers
          : [];

        compatibleChargers.forEach((handle) => {
          chargerHandles.add(handle);
        });
      });

      let compatibleChargers =
        motorData.chargers.filter((charger) => {
          return chargerHandles.has(
            charger.handle
          );
        });

      /*
       * Fallback:
       * If a charger is not linked to the model,
       * use chargers belonging to the selected brand.
       */
      if (!compatibleChargers.length) {
        compatibleChargers =
          motorData.chargers.filter((charger) => {
            return charger.motorBrand === brandHandle;
          });
      }
      appendOption(chargerSelect, {
  handle: 'no-charger',
  name: 'No Charger'
});
      uniqueByHandle(compatibleChargers).forEach(
        
        (charger) => {
          appendOption(chargerSelect, charger);
        }
      );
      if (chargerCards) {
  chargerCards.innerHTML = '';

  const noChargerCard = document.createElement('button');
  noChargerCard.type = 'button';
  noChargerCard.className =
    'smart-quote__option-card smart-quote__visual-card';
  noChargerCard.dataset.chargerHandle = 'no-charger';

  const noChargerContent = document.createElement('span');
  noChargerContent.className =
    'smart-quote__visual-card-content';

  const noChargerTitle = document.createElement('strong');
  noChargerTitle.className =
    'smart-quote__visual-card-title';
  noChargerTitle.textContent = 'No Charger';

  noChargerContent.appendChild(noChargerTitle);
  noChargerCard.appendChild(noChargerContent);

  noChargerCard.addEventListener('click', () => {
    chargerSelect.value = 'no-charger';

    chargerCards
      .querySelectorAll('.smart-quote__visual-card')
      .forEach((item) => {
        item.classList.remove('is-selected');
      });

    noChargerCard.classList.add('is-selected');

    chargerSelect.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  });

  chargerCards.appendChild(noChargerCard);

  uniqueByHandle(compatibleChargers).forEach((charger) => {
    const card = document.createElement('button');

    card.type = 'button';
    card.className =
      'smart-quote__option-card smart-quote__visual-card';

    card.dataset.chargerHandle = charger.handle;

    if (charger.image) {
      const imageWrap = document.createElement('div');
      imageWrap.className =
        'smart-quote__visual-card-media';

      const image = document.createElement('img');
      image.src = charger.image;
      image.alt = charger.name || charger.handle;
      image.loading = 'lazy';
      image.className =
        'smart-quote__visual-card-image';

      imageWrap.appendChild(image);
      card.appendChild(imageWrap);
    }

    const content = document.createElement('span');
    content.className =
      'smart-quote__visual-card-content';

    const title = document.createElement('strong');
    title.className =
      'smart-quote__visual-card-title';
    title.textContent =
      charger.name || charger.handle;

    content.appendChild(title);

    const price = Number(charger.sellingPrice || 0);

    if (price > 0) {
      const priceText = document.createElement('small');
      priceText.className =
        'smart-quote__visual-card-price';
     priceText.textContent =
  `+${formatDisplayPrice(
    priceIncGst(price)
  )}`;
      content.appendChild(priceText);
    }

    card.appendChild(content);

    card.addEventListener('click', () => {
      chargerSelect.value = charger.handle;

      chargerCards
        .querySelectorAll('.smart-quote__visual-card')
        .forEach((item) => {
          item.classList.remove('is-selected');
        });

      card.classList.add('is-selected');

      chargerSelect.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    });

    chargerCards.appendChild(card);
  });
}
    }

 motorBrandSelect.addEventListener(
  'change',
  () => {
    // Clear the previously selected automatic motor
    if (motorModelField) {
      motorModelField.value = '';
    }

    if (selectedMotorCard) {
      selectedMotorCard.innerHTML = '';
      selectedMotorCard.hidden = true;
    }

    // Clear old Remote cards
    if (remoteCards) {
      remoteCards.innerHTML = '';
    }

    // Clear old Charger cards
    if (chargerCards) {
      chargerCards.innerHTML = '';
    }

    populatePowerTypes(
      motorBrandSelect.value
    );

    updateAutomaticMotorModel();
  }
);
   powerTypeSelect.addEventListener(
  'change',
  () => {
    populateCompatibleAccessories(
      motorBrandSelect.value,
      powerTypeSelect.value
    );

    updateAutomaticMotorModel();
  }
);

function refreshMotorAvailability() {
  const selectedOperation = form.querySelector(
    'input[name="operation_type"]:checked'
  )?.value;

  if (selectedOperation !== 'motorised') {
    return;
  }
const width = Number(widthField?.value);
const drop = Number(dropField?.value);

if (
  !Number.isFinite(width) ||
  !Number.isFinite(drop) ||
  width <= 0 ||
  drop <= 0
) {
  return;
}

const previousBrand =
  motorBrandSelect?.value || '';

  const previousPowerType =
    powerTypeSelect?.value || '';

  const previousRemote =
    remoteSelect?.value || '';

  const previousCharger =
    chargerSelect?.value || '';

  populateMotorBrands();

  if (
    Number.isFinite(width) &&
    width >= 670 &&
    previousBrand
  ) {
    const brandCard = motorBrandCards?.querySelector(
      `[data-motor-brand-handle="${previousBrand}"]`
    );
    
    brandCard?.click();
 
    if (previousPowerType) {
      const powerTypeCard = root.querySelector(
        `[data-power-type-handle="${previousPowerType}"]`
      );

      powerTypeCard?.click();
    }

    if (previousRemote) {
      const remoteCard = root.querySelector(
        `[data-remote-handle="${previousRemote}"]`
      );

      remoteCard?.click();
    }

    if (previousCharger) {
      const chargerCard = root.querySelector(
        `[data-charger-handle="${previousCharger}"]`
      );

      chargerCard?.click();
    }
  }

  updateAutomaticMotorModel();
}

widthField?.addEventListener(
  'change',
  refreshMotorAvailability
);

dropField?.addEventListener(
  'change',
  refreshMotorAvailability
);

form
  .querySelectorAll('input[name="blind_type"]')
  .forEach((field) => {
    field.addEventListener(
      'change',
      refreshMotorAvailability
    );
  });
    form.addEventListener('change', (event) => {
            if (
        event.target.name !== 'operation_type'
      ) {
        return;
      }

      if (event.target.value === 'motorised') {
        populateMotorBrands();
      }
    });

    const selectedOperation = form.querySelector(
      'input[name="operation_type"]:checked'
    )?.value;

    if (selectedOperation === 'motorised') {
      populateMotorBrands();
    }
  }

  function initialiseAllMotorModules(
    container = document
  ) {
    if (container.matches?.('[data-smart-quote]')) {
      initialiseMotorModule(container);
    }

    container
      .querySelectorAll('[data-smart-quote]')
      .forEach(initialiseMotorModule);
  }

  function startMotorModules() {
    initialiseAllMotorModules(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startMotorModules
    );
  } else {
    startMotorModules();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initialiseAllMotorModules(event.target);
    }
  );
  function calculateArea(width, drop) {
  const widthMm = Number(width) || 0;
  const dropMm = Number(drop) || 0;

  if (!widthMm || !dropMm) {
    return 0;
  }

  return (widthMm * dropMm) / 1000000;
}

function findMotorSelectionRule({
  productType,
  blindType,
  area,
  rules
}) {
  const selectedProductType =
    normaliseValue(productType);

  const selectedBlindType =
    normaliseValue(blindType);

  return rules.find((rule) => {
    const ruleProductType =
      normaliseValue(rule.productType);

    let ruleBlindType =
      normaliseValue(rule.blindType);

    if (ruleBlindType === 'light-filtering') {
      ruleBlindType = 'light-filter';
    }

    return (
      ruleProductType === selectedProductType &&
      ruleBlindType === selectedBlindType &&
      area >= Number(rule.minimumArea) &&
      area <= Number(rule.maximumArea)
    );
  });
}

})();